<template>
   <div>
      <img @click="handleSetLanguage('en')" v-if="language==='zh'" src="../../assets/en.png" style="width:30px;cursor:pointer"/>
      <img @click="handleSetLanguage('zh')" v-if="language==='en'" src="../../assets/zh.png" style="width:30px;cursor:pointer"/>
    </div>
</template>

<script>
export default {
  computed: {
    language () {
      return this.$store.getters.language
    }
  },
  mounted () {
    const lang = this.language
    this.toggleTitle(lang)
  },
  methods: {
    handleSetLanguage (lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('app/setLanguage', lang)
      this.toggleTitle(lang)
    },
    toggleTitle (lang) {
      if (lang == 'en') {
        document.title = 'DSIM license management system'
      } else {
        document.title = 'DSIM权限管理系统'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LangSelect/index.vue